/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";

import { ThemeProvider } from "@mui/material";

import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import BaseGraph from "./BaseGraph";

import { useIsComponentMounted } from "../../../../../hooks/useIsComponentMounted";
import { useNitroStore } from "../../../../../store/Store";
import NitroService from "../../../../../utils/nitro.service";
import {
  formatByCalendarType,
  getAdjustedYears,
} from "../../../../../utils/Dates";

import { table2Theme } from "../Table2";

const uomFactor = 1;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ProductMixGraph = () => {
  const [product, mode] = useNitroStore((state) => [
    state.currentFilters,
    state.product,
    state.mode,
  ]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([] as any[]);
  const [rows, setRows] = useState([] as any[]);

  const startYear = new Date().getFullYear() - 4;
  const endYear = new Date().getFullYear();
  const [years, setYears] = useState(getAdjustedYears(endYear, "cal"));
  useEffect(() => {
    setYears(getAdjustedYears(endYear, "cal"));
  }, [endYear]);

  useEffect(() => {
    const newRows = formatByCalendarType(data, {
      calendarFormat: "cal",
      startYear,
      endYear,
      property: "productType",
    });
    setRows(newRows);
  }, [data, startYear, endYear]);

  const isComponentMounted = useIsComponentMounted();
  useEffect(() => {
    if (!isComponentMounted) return;

    const load = async () => {
      // if (!party) {
      //   // && (!cityNames || cityNames.length === 0)) {
      //   setData([]);
      //   return;
      // }

      try {
        setLoading(true);
        // const result = await NitroService.proxy(
        //   "ProductMix",
        //   {
        //     customerName: encodeURIComponent("GROWMARK INC"),
        //     modes: [mode],
        //     // industry,
        //     // marketer,
        //     // cityNames,
        //     // stateNames,
        //     startYear: Number(startYear),
        //     endYear: Number(endYear),
        //   },
        //   1,
        //   1000
        // );

        // setData(result);
      } catch (err) {
        console.error(err);
        // addNotification({
        //   message: "Failed to load product mix...",
        //   length: 10,
        // });
      }

      setLoading(false);
    };

    load();
  }, [isComponentMounted, mode, startYear, endYear]);

  const infoMessage = (
    <>
      Filter criteria: Customer Name, Modes, Industry, Cities, States
      <br />
      {/* UOM: {uom} */}
    </>
  );

  // useEffect(() => {
  //   if (!productType) return;

  //   const i = rows.findIndex((r) => r.productType === productType);

  //   const row = document.getElementById(rows[i]?.productType);
  //   row?.scrollIntoView({
  //     behavior: "smooth",
  //     block: "end",
  //     inline: "end",
  //   });
  // }, [rows, productType]);

  const body = (
    <ThemeProvider theme={table2Theme}>
      <TableContainer
        // component={Paper}
        style={{ maxHeight: 190, overflowY: "auto" }}
        sx={{ boxShadow: "none" }}
      >
        <Table stickyHeader size="small" aria-label="a dense table">
          <TableHead>
            <TableRow className="Header">
              <TableCell>Product</TableCell>
              <TableCell>{years[0]}</TableCell>
              <TableCell>{years[1]}</TableCell>

              <TableCell>{years[2]}</TableCell>
              <TableCell>{years[3]}</TableCell>
              <TableCell>{years[4]}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            id="tablebody"
            style={{ overflowY: "scroll", cursor: "pointer" }}
          >
            {rows &&
              rows.length > 0 &&
              rows.map((row) => (
                <TableRow
                  id={row.productType}
                  autoFocus={product === row.productType}
                  key={row.productType}
                  style={{
                    cursor: "pointer",
                    // backgroundColor:
                    //   productType === row.productType
                    //     ? "rgb(217,217,217, .3)"
                    //     : undefined,
                  }}
                  // onClick={(p: any) => {
                  //   if (setProductType) {
                  //     if (productType === row.productType) {
                  //       setProductType("");
                  //     } else {
                  //       setProductType(row.productType);
                  //     }
                  //   }
                  // }}
                >
                  <TableCell>{row.productType}</TableCell>

                  <TableCell>
                    {Math.round(row.year1 * uomFactor).toLocaleString("en", {
                      useGrouping: true,
                    })}
                  </TableCell>
                  <TableCell>
                    {Math.round(row.year2 * uomFactor).toLocaleString("en", {
                      useGrouping: true,
                    })}
                  </TableCell>
                  <TableCell>
                    {Math.round(row.year3 * uomFactor).toLocaleString("en", {
                      useGrouping: true,
                    })}
                  </TableCell>
                  <TableCell>
                    {Math.round(row.year4 * uomFactor).toLocaleString("en", {
                      useGrouping: true,
                    })}
                  </TableCell>
                  <TableCell
                    sx={{
                      paddingRight: "5px",
                    }}
                  >
                    {Math.round(row.year5 * uomFactor).toLocaleString("en", {
                      useGrouping: true,
                    })}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </ThemeProvider>
  );

  return (
    <BaseGraph
      // loading={loading}
      loading={false}
      title="PRODUCT MIX"
      infoMessage={infoMessage}
      height={200}
    >
      {body}
    </BaseGraph>
  );
};

export default ProductMixGraph;
